import {
  faBowlFood,
  faCircleCheck,
  faClock,
  faClose,
  faCloudMoon,
  faCookieBite,
  faEye,
  faFileLines,
  faFilter,
  faMountainSun,
  faRefresh,
  faSun,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Tab, Tabs } from "react-bootstrap";
import DataTable from "react-data-table-component";
import "./MealTracker.scss";
import axios from "axios";
import FoodIntakeReview from "./FoodIntakeReview";
import {
  Avatar,
  AvatarGroup,
  Box,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material";
import FoodIntakeFilter from "./FoodIntakeFilter";
import MainContext from "../../../context/MainContext";
import NutritionContext from "../../../context/NutritionContext";
import { getListFoodIntake } from "../../../utils/nutritionApi";

const MealTracker = () => {
  const [initComp, setInitComp] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  function formatTimestamp(timestamp) {
    const date = new Date(timestamp);

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // January is 0!
    const yyyy = date.getFullYear();

    const hh = String(date.getHours()).padStart(2, "0");
    const min = String(date.getMinutes()).padStart(2, "0");
    const ss = String(date.getSeconds()).padStart(2, "0");

    return (
      <div>
        {`${dd}-${mm}-${yyyy}`}
        <br />
        <small>
          <FontAwesomeIcon icon={faClock} style={{ color: "darkblue" }} />{" "}
          {`${hh}:${min}:${ss}`}
        </small>
      </div>
    );
  }

  const foodIntakeDTColumns = [
    {
      name: "ID",
      selector: (row) => parseInt(row.id),
      key: "id",
      minWidth: "10%",
      // sortable: true,
    },
    {
      name: "User",
      selector: (row) => row?.food_profile_id,
      key: "user",
      minWidth: "20%",
      // sortable: true,
      cell: (row) => (
        <div className="user-section">
          <span className="name">
            <b>Food Profile ID: </b>
            {row?.food_profile_id}
          </span>
          <span className="id">
            {"[User ID: "}
            {row.cc_profile?.user?.id}
            {"]"}
          </span>
        </div>
      ),
    },
    {
      name: "Meal Type",
      selector: (row) => row.meal_type,
      key: "name",
      minWidth: "15%",
      // sortable: true,
      cell: (row) => {
        const mealIcons = {
          breakfast: faMountainSun,
          lunch: faSun,
          dinner: faCloudMoon,
          snack: faCookieBite,
        };

        return (
          <div className="meal-type">
            <FontAwesomeIcon
              icon={mealIcons[row.meal_type]}
              className={row.meal_type}
            />
            {row.meal_type}
          </div>
        );
      },
    },
    {
      name: "Intake at",
      selector: (row) => formatTimestamp(row.intake_at),
      key: "name",
      minWidth: "15%",
      // sortable: true,
    },
    {
      name: "Intake Image",
      key: "name",
      minWidth: "20%",
      // sortable: true,
      cell: (row) => (
        <div className="food-intake-images">
          <AvatarGroup total={Math.min(row?.n_image, 5)}>
            {row?.cc_intake_images?.slice(0, 5)?.map((image, index) => (
              <Avatar key={index} alt="food" src={image?.thumbnail_url} />
            ))}
          </AvatarGroup>
        </div>
      ),
    },
    {
      name: "Status",
      key: "name",
      minWidth: "10%",
      // sortable: true,
      cell: (row) => (
        <>
          <div className="text-center verified-tick">
            {row.validated_by_user_id ? (
              <Tooltip title={"Verified"}>
                <FontAwesomeIcon icon={faCircleCheck} className="verified" />
              </Tooltip>
            ) : (
              <Tooltip title={"Processing"}>
                <FontAwesomeIcon icon={faClock} className="not-verified" />
              </Tooltip>
            )}
          </div>
        </>
      ),
    },
    {
      name: "View",
      minWidth: "10%",
      cell: (row) => (
        <div className="text-center">
          <Button
            variant="outline-primary"
            size="sm"
            className="mx-2 viewBtn action-button-responsive"
            onClick={() => {
              setSelectedFoodIntake(row);
              setShow(true);
            }}
          >
            <FontAwesomeIcon icon={faEye} /> <span>View</span>
          </Button>
        </div>
      ),
    },
  ];

  const paginationOptions = {
    rowsPerPageText: "Rows per page:",
    rangeSeparatorText: "of",
    // noRowsPerPage: true,
  };

  const { headers, setIsPreLoading, ShowNotification } =
    useContext(MainContext);

  const {
    foodIntakeParam,
    setFoodIntakeParam,
    foodIntakeList,
    setFoodIntakeList,
    foodIntakeCount,
    setFoodIntakeCount,
    initialRender,
    setInitialRender,
  } = useContext(NutritionContext);

  const { REACT_APP_BASE__URL } = process.env;
  // const [loading, setLoading] = useState(true);

  /* Meal Tracker */

  const [selectedFoodIntake, setSelectedFoodIntake] = useState([]);

  const getFoodIntakeList = async () => {
    setIsPreLoading(true);

    const params = [];

    for (const key in foodIntakeParam) {
      // if (foodIntakeParam[key]) {
      params.push(`${key}=${encodeURIComponent(foodIntakeParam[key])}`);
      // }
    }
    const UrlParam = `?${params.join("&")}`;

    let requestData = foodIntakeParam;

    try {
      const getListFoodintakeResponse = await getListFoodIntake(requestData);

      setFoodIntakeList(getListFoodintakeResponse.data?.food_intake_summary);
      setFoodIntakeCount({
        total_count: getListFoodintakeResponse.data?.total_count,
        validated_count: getListFoodintakeResponse?.data?.validated_count,
        non_validated_count:
          getListFoodintakeResponse?.data?.non_validated_count,
      });
    } catch (error) {
      console.error(
        "Error fetching data:",
        error.response ? error.response.data : error.message
      );
      ShowNotification("error", error.message);
    } finally {
      setIsPreLoading(false);
    }

    //old one
    // try {
    //   const response = await axios.get(
    //     `${REACT_APP_BASE__URL}/v3/int/human-token/nutrition/food-intake/list${UrlParam}`,
    //     { headers }
    //   );
    //   setFoodIntakeList(response?.data?.data?.food_intake_summary);
    //   setFoodIntakeCount({
    //     total_count: response?.data?.data?.total_count,
    //     validated_count: response?.data?.data?.validated_count,
    //     non_validated_count: response?.data?.data?.non_validated_count,
    //   });
    //   setIsPreLoading(false);
    // } catch (error) {
    //   console.error("Error:", error);
    //   setIsPreLoading(false);
    // } finally {
    //   setIsPreLoading(false);
    // }
  };

  //Initial Rendering
  useEffect(() => {
    if (initialRender) {
      getFoodIntakeList();
      setInitialRender(false);
    }

    setTimeout(() => {
      setInitComp(false);
    }, 1000);
  }, []);

  //Param Dependency
  useEffect(() => {
    if (!initialRender && !initComp) {
      getFoodIntakeList();
    }
  }, [foodIntakeParam]);

  //Offset Change
  const handleFoodIntakePageChange = (page) => {
    console.log(page);
    if (!initialRender) {
      const newOffset = (page - 1) * foodIntakeParam?.limit;
      setFoodIntakeParam((prevFoodIntakeParam) => ({
        ...prevFoodIntakeParam,
        offset: newOffset,
      }));
      setCurrentPage(page);
    }
  };

  //Rows Count Change
  const handleFoodIntakeRowsPerPageChange = (newPerPage) => {
    if (!initialRender) {
      if (newPerPage !== foodIntakeParam?.limit) {
        setFoodIntakeParam((prevFoodIntakeParam) => ({
          ...prevFoodIntakeParam,
          limit: newPerPage,
        }));
      }
    }
  };

  const [show, setShow] = useState(false);
  const [filterShow, setFilterShow] = useState(false);
  const [filterMealTypes, setFilterMealTypes] = useState([]);

  return (
    <div>
      <section className="component-heading mt-1 mb-3">
        <FontAwesomeIcon icon={faFileLines} className="mx-2" /> Nutrition
        Tracker
      </section>

      <div>
        <Box sx={{ flexGrow: 1 }} className="m-0 home-card">
          <Grid container spacing={2}>
            <Grid item md={4} xs={12}>
              <Card className="primary">
                <Typography variant="h6" className="heading">
                  Total Food Intake
                </Typography>
                <Typography variant="body1" className="count">
                  {foodIntakeCount?.validated_count +
                    foodIntakeCount?.non_validated_count || 0}
                </Typography>
              </Card>
            </Grid>
            <Grid item md={4} xs={6}>
              <Card className="success">
                <Typography variant="h6" className="heading">
                  Validated Count
                </Typography>
                <Typography variant="body1" className="count">
                  {foodIntakeCount?.validated_count || 0}
                </Typography>
              </Card>
            </Grid>
            <Grid item md={4} xs={6}>
              <Card className="danger">
                <Typography variant="h6" className="heading">
                  Pending Validation
                </Typography>
                <Typography variant="body1" className="count">
                  {foodIntakeCount?.non_validated_count || 0}
                </Typography>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </div>

      <div className="action-button-group">
        <Button
          variant="outline-secondary"
          size="sm"
          className="my-2"
          onClick={() => {
            // getFoodIntakeList();
            setFoodIntakeParam((prevFoodIntakeParam) => ({
              ...prevFoodIntakeParam,
              offset: 0,
            }));
            setCurrentPage(1);
            setResetPaginationToggle(!resetPaginationToggle);
          }}
        >
          <FontAwesomeIcon icon={faRefresh} /> <span>Refresh</span>
        </Button>

        <Button
          variant="outline-primary"
          size="sm"
          className="my-2 mx-2"
          onClick={() => {
            setFilterShow(true);
          }}
        >
          <FontAwesomeIcon icon={faFilter} /> <span>Filter</span>
        </Button>

        <Button
          variant="outline-danger"
          size="sm"
          className="my-2"
          onClick={() => {
            setFoodIntakeParam((prevState) => ({
              ...prevState,
              meal_type: [],
              is_validated: "",
              start_time: "",
              end_time: "",
              offset: 0,
            }));
            setFilterMealTypes([]);
            setResetPaginationToggle(!resetPaginationToggle);
          }}
        >
          <FontAwesomeIcon icon={faClose} /> <span>Clear Filter</span>
        </Button>
      </div>

      <div className="dt-section meal-dt p-0 mt-1">
        <DataTable
          columns={foodIntakeDTColumns}
          striped
          data={foodIntakeList}
          pagination
          searchable
          // progressPending={loading}
          responsive={true}
          paginationPerPage={foodIntakeParam?.limit || 10}
          paginationComponentOptions={paginationOptions}
          paginationServer
          paginationTotalRows={foodIntakeCount?.total_count}
          onChangePage={handleFoodIntakePageChange}
          onChangeRowsPerPage={handleFoodIntakeRowsPerPageChange}
          dense
          paginationDefaultPage={1}
          paginationResetDefaultPage={!resetPaginationToggle}
        />
      </div>

      <FoodIntakeReview
        show={show}
        setShow={setShow}
        selectedFoodIntake={selectedFoodIntake}
        getFoodIntakeList={getFoodIntakeList}
      />
      <FoodIntakeFilter
        show={filterShow}
        setShow={setFilterShow}
        setCurrentPage={setCurrentPage}
        filterMealTypes={filterMealTypes}
        setFilterMealTypes={setFilterMealTypes}
        setResetPaginationToggle={setResetPaginationToggle}
        resetPaginationToggle={resetPaginationToggle}
      />
    </div>
  );
};

export default MealTracker;
